<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-crud-table [crudService]="crudService"
                [transPartKey]="transPartKey" [fieldId]="fieldId" [fieldName]="'username'" [fieldEnabled]="'enabled'"
                [tableConfig]="tableConfig" [newRecord]="newRecord" [tableLoading]="tableLoading"
                [(formRecord)]="formRecord" [formConfig]="formConfig"
                [(dialogFormVisible)]="dialogFormVisible"
                [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                [(selectedRecords)]="selectedRecords" [dialogFormTitle]="dialogFormTitle"
                [contextMenuConfig]="contextMenuConfig" [headerButtonConfig]="headerButtonConfig"
                [prepareForCreate]="prepareRecordForCreate"
                [prepareForEdit]="prepareRecordForEdit" [prepareForClone]="prepareRecordForClone"
                [(tableCurrentRequest)]="tableCurrentRequest" [(records)]="records" (onSave)="onSaved()"
                [lazyLoadOnInit]="true" [totalRecords]="totalRecords" (onContextMenuShow)="refreshContextMenu()"
                [globalErrorMessage]="globalErrorMessage"
                [globalInfoMessage]="globalInfoMessage"
                [dialogClass]="'cc-user-form-dialog'"
                [deleteRoles]="deleteRoles"
></app-crud-table>

<app-batch-update-user-form [(dialogFormVisible)]="batchUpdateDialogVisible"
                               [selectedRecords]="selectedRecords"
                               [formRecord]="batchFormRecord"
                               [transPartKey]="transPartKey"
                               (onSavedForm)="onSaved()"
                               [userGroups]="userGroups"
                            [authorities]="authorities"
                            [countries]="countries"
                            [languages]="languages"
                            [notifications]="notifications"
></app-batch-update-user-form>
